<template>
    <div v-if="groupDetail" class="left">
        <div class="na-form">
            <DxTabPanel>
                <DxItem :title="tx.TabBasis">
                    <div class="dx-fieldset">
                        <div class="dx-field">
                            <div class="dx-field-label">ID:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='groupDetail.GrpId' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldName}}</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='groupDetail.GrpName' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldCaption}}</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='groupDetail.GrpCaptionDE' />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldDesc}}</div>
                            <div class="dx-field-value">
                                <DxTextArea :height="90" v-model:value='groupDetail.GrpComment' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldStartPage}}</div>
                            <div class="dx-field-value">
                                <DxSelectBox :dataSource="startPageList" displayExpr="Name" valueExpr="Url" v-model:value="groupDetail.GrpStartUrl">
                                </DxSelectBox>
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldNotifTemp}}</div>
                            <div class="dx-field-value">
                                <DxSelectBox :dataSource="notificationSimpleList" displayExpr="NevName" valueExpr="NevId" v-model:value="groupDetail.NevId">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldDocuTyp}}</div>
                            <div class="dx-field-value">
                                <DxSelectBox :dataSource="termTypeList" displayExpr="TetName" valueExpr="TetId" v-model:value="groupDetail.TetId">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldAttacheTty}}</div>
                            <div class="dx-field-value">
                                <DxSelectBox :dataSource="ttySimpleList" displayExpr="TtyName" valueExpr="TtyId" v-model:value="groupDetail.AttachTtyId">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldProfilWithFirstLogin}}</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='groupDetail.GrpFullfillIntern' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldAutoReg}}</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='groupDetail.GrpCanAutoRegister' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldEmailMustBeConfirmed}}</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='groupDetail.GrpEmailMustBeConfirmed' />
                            </div>
                        </div>
                        <div class="dx-field" v-if="groupDetail.GrpCanAutoRegister">
                            <div class="dx-field-label">Auto-Registration-Email-Pattern:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='groupDetail.GrpAutoRegistrationEmailPattern' />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldLocked}}</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='groupDetail.GrpLocked' />
                            </div>
                        </div>

                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldValidFrom}}</div>
                            <div class="dx-field-value">
                                <DxDateBox v-model:value='groupDetail.GrpBeginActive' />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldValidUntil}}</div>
                            <div class="dx-field-value">
                                <DxDateBox v-model:value='groupDetail.GrpEndActive' />
                            </div>

                        </div>


                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldChangedOn}}</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='groupDetail.GrpChangedOn' :readOnly="true" />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldChangedBy}}</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='groupDetail.GrpChangedBy' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldCreatedOn}}</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='groupDetail.GrpCreatedOn' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldCreatedBy}}</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='groupDetail.GrpCreatedBy' :readOnly="true" />
                            </div>
                        </div>
                    </div>
                </DxItem>

                <DxItem :title="tx.TabRights">
                    <DxDataGrid :data-source="fieldAccess"
                                :key-expr="ObjId"
                                :filter-row-visible="true"
                                :row-alternation-enabled="true"
                                @row-updating="rowUpdating">
                        <DxEditing :allow-updating="true"
                                   :allow-adding="false"
                                   :allow-deleting="false"
                                   mode="cell" />
                        <DxColumn data-field="ObjId"
                                  :allow-editing="false"
                                  caption="ID"
                                  data-type="number" />
                        <DxColumn data-field="ObjName"
                                  :allow-editing="false"
                                  :caption="tx.ColCaption"
                                  data-type="string" />
                        <DxColumn data-field="ObjAlias"
                                  :allow-editing="false"
                                  :caption="tx.ColDesc"
                                  data-type="string" />
                        <DxColumn data-field="CanRead"
                                  :caption="tx.ColRead"
                                  alignment="center"
                                  data-type="boolean" />
                        <DxColumn data-field="CanUpdate"
                                  :caption="tx.ColUpdate"
                                  alignment="center"
                                  data-type="boolean" />
                        <DxColumn data-field="CanInsert"
                                  :caption="tx.ColInsert"
                                  alignment="center"
                                  data-type="boolean" />
                        <DxColumn data-field="CanDelete"
                                  :caption="tx.ColDelete"
                                  alignment="center"
                                  data-type="boolean" />
                        <DxColumn data-field="ObjOrder2"
                                  :visible="false"
                                  :sort-index="0"
                                  :caption="tx.ColDesc"
                                  data-type="boolean" />
                        <DxSearchPanel :visible="true" />
                        <DxFilterRow :visible="true" />
                        <DxHeaderFilter :visible="true" />
                        <DxFilterPanel :visible="true" />
                        <template #read-template="{ data }">
                            <div class="faTemplate">
                                <div v-if="data.data.ShowRead">
                                    <DxCheckBox v-model:value="data.data.CanRead"></DxCheckBox>
                                </div>
                            </div>
                        </template>
                        <template #update-template="{ data }">
                            <div class="faTemplate">
                                <div v-if="data.data.ShowUpdate">
                                    <DxCheckBox v-model:value="data.data.CanUpdate"></DxCheckBox>
                                </div>
                            </div>
                        </template>
                        <template #insert-template="{ data }">
                            <div class="faTemplate">
                                <div v-if="data.data.ShowInsert">
                                    <DxCheckBox v-model:value="data.data.CanInsert"></DxCheckBox>
                                </div>
                            </div>
                        </template>
                        <template #delete-template="{ data }">
                            <div class="faTemplate">
                                <div v-if="data.data.ShowDelete">
                                    <DxCheckBox v-model:value="data.data.CanDelete"></DxCheckBox>
                                </div>
                            </div>
                        </template>
                        <DxSearchPanel :visible="true" />
                    </DxDataGrid>
                </DxItem>
                <DxItem :title="tx.TabManagedGroups">
                    <DxDataGrid :data-source="managedGroupsByGroupList"
                                :key-expr="GrpId"
                                :filter-row-visible="true"
                                :row-alternation-enabled="true"
                                @row-updating="rowUpdating">
                        <DxEditing :allow-updating="true"
                                   :allow-adding="false"
                                   :allow-deleting="false"
                                   mode="cell" />
                        <DxColumn data-field="GrpName"
                                  :allow-editing="false"
                                  :sort-index="0"
                                  :caption="tx.ColUsrGrp"
                                  data-type="string" />
                        <DxColumn data-field="Managed"
                                  :caption="tx.ColManaged"
                                  data-type="boolean" />
                        <DxSearchPanel :visible="true" />
                        <DxFilterRow :visible="true" />
                        <DxHeaderFilter :visible="true" />
                        <DxFilterPanel :visible="true"  />
                    </DxDataGrid>
                </DxItem>
                <DxItem :title="tx.TabAccConfig">
                    <DxDataGrid :data-source="accountConfigList"
                                :key-expr="AfiId"
                                :filter-row-visible="true"
                                :row-alternation-enabled="true"
                                @row-updating="rowUpdating">
                        <DxEditing :allow-updating="true"
                                   :allow-adding="false"
                                   :allow-deleting="false"
                                   mode="cell" />
                        <DxColumn data-field="AfiName"
                                  :allow-editing="false"
                                  caption="Name"
                                  data-type="string" />
                        <DxColumn data-field="AfiCaptionDE"
                                  :allow-editing="false"
                                  caption="Caption"
                                  data-type="string" />
                        <DxColumn data-field="AfiDescriptionDE"
                                  :allow-editing="false"
                                  caption="Description"
                                  data-type="string" />
                        <DxColumn data-field="AcfRequired"
                                  caption="Required"
                                  data-type="boolean" />
                        <DxColumn data-field="AcfShowInMyAccount"
                                  caption="My Account"
                                  data-type="boolean" />
                        <DxColumn data-field="AcfShowInRegistration"
                                  caption="Registration"
                                  data-type="boolean" />
                        <DxColumn data-field="AcfShowInUserDetail"
                                  caption="User Detail"
                                  data-type="boolean" />
                        <DxColumn data-field="AfiPosition"
                                  :visible="false"
                                  :sort-index="0"
                                  caption="Position"
                                  data-type="number" />
                        <DxSearchPanel :visible="true" />
                        <DxFilterRow :visible="true" />
                        <DxHeaderFilter :visible="true" />
                        <DxFilterPanel :visible="true" />
                    </DxDataGrid>
                </DxItem>
            </DxTabPanel>
            <div class="na-buttons-row">
                <div>
                    <DxButton :text="btn.BtnSave"
                              :type="saveButtonType"
                              :disabled="saveButtonDisabled"
                              styling-mode="contained"
                              @click="onSaveClick($event)" />
                </div>
                <div>
                    <DxButton :text="btn.BtnDelete"
                              type="default"
                              styling-mode="contained"
                              @click="onDeleteClick()" />
                </div>
                <div>
                    <DxButton :text="btn.BtnCancel"
                              type="default"
                              styling-mode="outlined"
                              @click="onCloseClick()" />
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .faTemplate.dx-template-wrapper div {
        text-align: center;
    }
</style>
<script>
    import axios from "axios";
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import { DxTextBox, DxTextArea } from 'devextreme-vue';
    import { DxButton } from 'devextreme-vue/button';
    import { DxDateBox } from 'devextreme-vue/date-box';
    import { DxTabPanel } from 'devextreme-vue/tab-panel';
    import { DxDataGrid, DxColumn, DxEditing, DxSearchPanel, DxFilterRow, DxHeaderFilter, DxFilterPanel } from 'devextreme-vue/data-grid';
    import notify from 'devextreme/ui/notify';
    import '../assets/detailForm.less';
    import { confirm, alert } from "devextreme/ui/dialog";
    import { DxItem } from 'devextreme-vue/html-editor';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import $ from 'jquery';
    const baseUri = "WebApi.asmx/api/groupService";
    export default {
        name: 'TopicTypeDetail',
        components: {
            DxButton,
            DxTextBox,
            DxDateBox,
            DxItem,
            DxCheckBox,
            DxTabPanel,
            DxDataGrid,
            DxColumn,
            DxEditing,
            DxSearchPanel,
            DxTextArea,
            DxSelectBox,
            DxFilterRow,
            DxHeaderFilter,
            DxFilterPanel
        },
        data() {
            return {
                isSaving: false,
                tx: {
                    TabBasis: this.$LanguageProvider.GetResource("tabBasis", "Caption", "Basic Data"),
                    TabRights: this.$LanguageProvider.GetResource("tabRights", "Caption", "Access Rights"),
                    TabAccConfig: this.$LanguageProvider.GetResource("tabAccConfig", "Caption", "Account Configuration"),
                    TabManagedGroups: this.$LanguageProvider.GetResource("tabManagedGroups", "Caption", "Administered Groups"),
                    FieldName: this.$LanguageProvider.GetResource("fieldName", "Caption", "Internal Name:"),
                    FieldCaption: this.$LanguageProvider.GetResource("fieldCaption", "Caption", "Caption:"),
                    FieldDesc: this.$LanguageProvider.GetResource("fieldDesc", "Caption", "Description:"),
                    FieldAutoReg: this.$LanguageProvider.GetResource("fieldAutoReg", "Caption", "Automated Registration"),
                    FieldEmailMustBeConfirmed: this.$LanguageProvider.GetResource("fieldEmailMustBeConfirmed", "Caption", "Email Must Be Confirmed"),
                    FieldStartPage: this.$LanguageProvider.GetResource("fieldStartPage", "Caption", "Start Page:"),
                    FieldNotifTemp: this.$LanguageProvider.GetResource("fieldNotifTemp", "Caption", "Notification Template:"),
                    FieldDocuTyp: this.$LanguageProvider.GetResource("fieldDocuTyp", "Caption", "Document Type:"),
                    FieldAttacheTty: this.$LanguageProvider.GetResource("fieldAttacheTty", "Caption", "Attach Topic of Type:"),
                    FieldLocked: this.$LanguageProvider.GetResource("fieldLocked", "Caption", "Gesperrt"),
                    FieldProfilWithFirstLogin: this.$LanguageProvider.GetResource("fieldProfilWithFirstLogin", "Caption", "Fullfill profile after first login"),
                    FieldChangedOn: this.$LanguageProvider.GetResource("fieldChangedOn", "Caption", "Changed On:"),
                    FieldValidUntil: this.$LanguageProvider.GetResource("fieldValidUntil", "Caption", "Valid Until:"),
                    FieldChangedBy: this.$LanguageProvider.GetResource("fieldChangedBy", "Caption", "Changed By:"),
                    FieldValidFrom: this.$LanguageProvider.GetResource("fieldValidFrom", "Caption", "Valid From:"),
                    FieldCreatedOn: this.$LanguageProvider.GetResource("fieldCreatedOn", "Caption", "Created On:"),
                    FieldCreatedBy: this.$LanguageProvider.GetResource("fieldCreatedBy", "Caption", "Created By:"),
                    ColUsrGrp: this.$LanguageProvider.GetResource("colUsrGrp", "Caption", "User Group"),
                    ColManaged: this.$LanguageProvider.GetResource("colManaged", "Caption", "Administered"),
                    ColDesc: this.$LanguageProvider.GetResource("colDesc", "Caption", "Description"),
                    ColRead: this.$LanguageProvider.GetResource("colRead", "Caption", "Read"),
                    ColUpdate: this.$LanguageProvider.GetResource("colUpdate", "Caption", "Update"),
                    ColInsert: this.$LanguageProvider.GetResource("colInsert", "Caption", "Create"),
                    ColDelete: this.$LanguageProvider.GetResource("colDelete", "Caption", "Delete"),
                    ColCaption: this.$LanguageProvider.GetResource("colCaption", "Caption", "Caption"),
                },
                btn: {
                    BtnSave: this.$LanguageProvider.GetResource("btnSave", "Caption", "Update"),
                    BtnDelete: this.$LanguageProvider.GetResource("btnDelete", "Caption", "Delete"),
                    BtnCancel: this.$LanguageProvider.GetResource("btnCancel", "Caption", "Cancel"),
                }
            }; 
        },
        created: function () {
            let vm = this
            this.$store.dispatch("getGroupDetail", { grpId: vm.grpId })
            this.$store.dispatch("getStartPages", {})
            this.$store.dispatch("getManagedGroupsByGroupId", { grpId: vm.grpId })
            this.$store.dispatch("getAccountConfiguration", { grpId: vm.grpId, manId: 1 })
            this.$store.dispatch("getTermTypeList")
            this.$store.dispatch("getTtySimpleList")
            this.$store.dispatch("getNotificationSimpleList")
        },
        computed: {
            groupDetail() {
                return this.$store.state.groupStore.groupDetail
            },
            termTypeList() {
                return this.$store.state.termTypeStore.termTypeList
            },
            ttySimpleList() {
                return this.$store.state.topicTypeStore.ttySimpleList
            },
            notificationSimpleList() {
                return this.$store.state.notificationEventStore.notificationSimpleList
            },
            groupDetailIsLoading() {
                return this.$store.state.groupStore.groupDetailIsLoading
            },
            groupDetailText() {
                return JSON.stringify(this.$store.state.groupStore.groupDetail)
            },
            startPageList() {
                return this.$store.state.groupStore.startPageList
            },
            startPageListIsLoading() {
                return this.$store.state.groupStore.startPageListIsLoading
            },
            managedGroupsByGroupList() {
                return this.$store.state.groupStore.managedGroupsByGroupList
            },
            managedGroupsByGroupListText() {
                return JSON.stringify(this.$store.state.groupStore.managedGroupsByGroupList)
            },
            managedGroupsByGroupListLoading() {
                return this.$store.state.groupStore.managedGroupsByGroupListIsLoading
            },
            accountConfigList() {
                return this.$store.state.accountConfigStore.accountConfigList
            },
            accountConfigListText() {
                return JSON.stringify(this.$store.state.accountConfigStore.accountConfigList)
            },
            fieldAccess() {
                return this.$store.state.groupStore.fieldAccess
            },
            fieldAccessText() {
                return JSON.stringify(this.$store.state.groupStore.fieldAccess)
            },
            saveButtonType() {
                return this.changed ? "success" : "normal"
            },
            saveButtonDisabled() {
                return this.changed ? false : true
            },
            changed() {
                return this.$store.state.groupStore.groupDetailChanged
                    || this.$store.state.groupStore.fieldAccessChanged
                    || this.$store.state.accountConfigStore.accountConfigListChanged
                    || this.$store.state.groupStore.managedGroupsByGroupListChanged
            },
        },
        props: {
            grpId: {
                type: [Number],
                required: true,
                default: 0
            },
        },
        watch: {
            groupDetailText: function (newVal, oldVal) {
                if (oldVal != "{}" && !this.groupDetailIsLoading && oldVal != newVal) {
                    this.$store.state.groupStore.groupDetailChanged = true
                }
            },
            fieldAccessText: function (newVal, oldVal) {
                if (oldVal != "[]" && !this.fieldAccessIsLoading && oldVal != newVal) {
                    this.$store.state.groupStore.fieldAccessChanged = true
                }
            },
            managedGroupsByGroupListText: function (newVal, oldVal) {
                if (oldVal != "[]" && !this.managedGroupsByGroupListIsLoading && oldVal != newVal) {
                    this.$store.state.groupStore.managedGroupsByGroupListChanged = true
                }
            },
            accountConfigListText: function (newVal, oldVal) {
                if (oldVal != "[]" && !this.fieldAccessIsLoading && oldVal != newVal) {
                    this.$store.state.accountConfigStore.accountConfigListChanged = true
                }
            },
            changed: function (newVal) {
                if (!newVal && this.isSaving) {
                    this.isSaving = false
                    notify("The changes were saved successfully")
                }
            },
        },
        methods: {
            onCloseClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onSaveClick() {
                this.isSaving = true
                this.$store.dispatch("saveGroupDetail")
                this.$store.dispatch("saveAccountConfiguration")
                this.$store.dispatch("saveManagedGroupsByGroupList")
            },
            onDeleteClick() {
                let result = confirm("do you really want to delete this record?", "Confirm delete");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        var formData = new FormData()
                        formData.append("data", JSON.stringify(this.groupDetail))
                        axios
                            .post(baseUri + '/Delete', formData)
                            .then(res => {
                                if (res.data.success) {
                                    notify(`The record has been successfully deleted`);
                                    $("form").attr("action", window.location.pathname + "?action=cancel").submit();
                                }
                                else { alert(`error: ${res.data.errorMessage}`) }
                            })
                    }
                });
            }, 
        }
    }
</script>
<style>
</style>
